import { useMemo } from 'react';
import Comments from 'components/Comments';
import { userSelector } from 'slices/auth.slice';
import type { TOrganizationNodeDrawer } from 'slices/organizationHierarchy.slice';
import { useAppSelector } from 'slices/store';
import { hasPermissions } from '@timeedit/types/lib/utils/permissionCalculator';
import { AffiliatedData } from './Sections/AffiliatedData';
import { GeneralInfo } from './Sections/GeneralInfo';

export type OrgDrawerContentProps = {
  data: TOrganizationNodeDrawer;
  onChange: (data: { key: string; value: string | undefined }) => void;
};
export const OrgDrawerContent = ({
  data: value,
  onChange,
}: OrgDrawerContentProps) => {
  const authUser = useAppSelector(userSelector);

  const hasEditPermission = useMemo(
    () =>
      hasPermissions(authUser?.appPermissions, authUser?.scopes, {
        permissions: ['TE_ADMIN::manageOrgs'],
      }),
    [authUser]
  );

  const onChangeValue = (key: string, value: string | undefined) => {
    onChange({ key, value });
  };
  return (
    <>
      <GeneralInfo
        data={value}
        onChangeValue={onChangeValue}
        hasEditPermission={hasEditPermission}
      />
      <AffiliatedData data={value} />
      <Comments
        disabled={!hasEditPermission}
        value={value?.description || ''}
        onChange={(e) => onChangeValue('description', e)}
      />
    </>
  );
};
